var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"columns is-vcentered"},[_c('div',{staticClass:"column is-narrow"},[_c('SellerSelect',{attrs:{"primary":_vm.primary}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }